window.keycloak = Keycloak({
	realm: document.getElementById('keycloakAdapterRealm')?.value,
	url: document.getElementById('keycloakAdapterUrl')?.value,
	clientId: document.getElementById('keycloakAdapterClientId')?.value,
	'enable-cors': true,
});

window.keycloak.onAuthSuccess = function () {
	this.onAuthenticatedQueue.forEach(function (callback) {
		callback();
	});

	this.refreshInterval = setInterval(function () {
		window.keycloak.updateToken(120);
	}, 60 * 1000);
};

window.keycloak.onAuthenticatedQueue = [];
window.keycloak.onAuthenticated = function (callback) {
	if (this.authenticated) {
		callback();
	} else {
		this.onAuthenticatedQueue.push(callback);
	}
};

window.keycloak.getBearerToken = function () {
	return this.token ? `Bearer ${this.token}` : null;
};

// eslint-disable-next-line no-unused-vars
function initKeycloak() {
	window.keycloak.init({
		onLoad: 'check-sso',
		silentCheckSsoRedirectUri: document.getElementById('keycloakAdapterSilentCheckSsoRedirectUri')?.value,
	});
}

initKeycloak();
